import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPaperPlane, faHandshake, faUser } from '@fortawesome/free-regular-svg-icons';
import styles from '../styles/components/whatWeDo.module.css';
import globalStyles from '../styles/global.module.css';

const WhatWeDoSection = () => {
  return (
    <section className={styles.whatWeDoSection}>
      <div className={styles.whatWeDoContainer}>
        <h2 className={styles.sectionTitle}>What we do</h2>
        <div className={styles.featuresGrid}>
          <div className={styles.featureItem}>
            <div className={styles.featureCard}>
              <span className={styles.featureIcon}>
                <FontAwesomeIcon icon={faPaperPlane} size="2x" />
              </span>
              <div className={styles.featureContent}>
                <div className={styles.featureText}>
                  Supporting Ecosystem participants, with Legal, Administrative, project management and other services.
                </div>
              </div>
            </div>
          </div>
          <div className={styles.featureItem}>
            <div className={styles.featureCard}>
              <span className={styles.featureIcon}>
                <FontAwesomeIcon icon={faPaperPlane} size="2x" />
              </span>
              <div className={styles.featureContent}>
                <div className={styles.featureText}>
                  Promoting The ecosystem participants and Education related to high tech trends, opportunities
                </div>
              </div>
            </div>
          </div>
          <div className={styles.featureItem}>
            <div className={styles.featureCard}>
              <span className={styles.featureIcon}>
                <FontAwesomeIcon icon={faHandshake} size="2x" />
              </span>
              <div className={styles.featureContent}>
                <div className={styles.featureText}>
                  Serving as a Human resource Hub, IT Headhunting, also DevRel think tank for Ecosystem participants as well as for Georgian Businesses who would like to have a Quality Human resources in IT, hardware and Software
                </div>
              </div>
            </div>
          </div>
          <div className={styles.featureItem}>
            <div className={styles.featureCard}>
              <span className={styles.featureIcon}>
                <FontAwesomeIcon icon={faUser} size="2x" />
              </span>
              <div className={styles.featureContent}>
                <div className={styles.featureText}>
                  Conduct Educational Services for the members and for non-members of our association;
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhatWeDoSection; 